export default {
	computed: {
		clientGroup() {
			return this.$authed().clientGroup;
		},
	}
};
